import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../context/AppContext";

const buildInitialForm = (userData) => ({
  Title: "",
  AnnouncementDate: "",
  AssignToBranchId: [],
  Message: "",
  PriorityId: "",
  AttachmentPath: null,
  AttachmentPreview: "",
  OrgId: Number(userData.OrgId),
  CreatedBy: Number(userData.EmpId),
  ViewCount: 0,
  AssignToTeamId: 0,
  AssignToEmployeeId: 0,
});

const useAnnouncementForm = () => {
  const { userData } = useContext(AppContext);
  const [form, setForm] = useState(() => buildInitialForm(userData));
  const [validated, setValidated] = useState(false);
  const [selectedBranches, setSelectedBranches] = useState([]);

  const updateField = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const reset = (overrides) => {
    setForm({ ...buildInitialForm(userData), ...(overrides || {}) });
    setSelectedBranches([]);
    setValidated(false);
  };

  const load = (announcement) => {
    setForm({ ...buildInitialForm(userData), ...announcement });
    setValidated(false);
  };

  useEffect(() => {
    const branchIds = selectedBranches.map((b) => b.value);
    setForm((prev) => ({ ...prev, AssignToBranchId: branchIds }));
  }, [selectedBranches]);

  return {
    form,
    setForm,
    updateField,
    validated,
    setValidated,
    selectedBranches,
    setSelectedBranches,
    reset,
    load,
  };
};

export default useAnnouncementForm;
